<template>
  <div id="navBar">
  <div class="navbar">
      <ul class="nav navbar-nav">
        <router-link :to="{path:'/Home'}">
         <li class="item">
          <img src="/static/images/common/logo.png" alt="">
        </li>
        </router-link>
        <li class="item">
          <ul>
            <label v-for="(item,index) in menuList" :key="item.name">
            <router-link :to="{path:'/'+item.link}" v-if="index!=1">
              <li :class="linkName ==item.link?'active':''">
              <span>{{$t(item.name)}}</span>
              </li>
            </router-link>
            <li :class="linkName ==item.link?'active':''" @mouseover="menuShows()" v-if="index==1">
            <span>{{$t(item.name)}}<img src="/static/images/common/ic_more.png" alt=""></span>
            </li>
            </label>
          </ul>
        </li>

        <!-- <li>
          <span>{{$t("content1_txt.con_tit")}}</span>
        </li> -->
        <li class="item languageBtn">
          <i class="iconfont icon-china"></i>
          <el-dropdown @command="handleCommand" trigger='click'>
            <span class="el-dropdown-link">
              <img :src="countryImg" alt="" class="countryImg">{{languageText}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item.name" v-for="(item,index) in languageList" :key="index"><img :src="item.img" alt="" class="countryImg">{{item.text}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </div>
    <transition name="fade">
      <div class="navMenu active" v-show="menuShow" @mouseleave="menuHiddens()">
        <div class="con">
          <router-link :to="{path:'/Software'}">
            <div class="left">
              <div class="menuImg"><img src="/static/images/common/ic_app.png" alt=""></div>
              <div>
                <div class="title">{{$t("header.tit1")}}</div>
                <div class="titleSub">
                  <ul>
                    <li>{{$t("header.titSub1.text1")}}</li>
                    <li>{{$t("header.titSub1.text2")}}</li>
                    <li>{{$t("header.titSub1.text3")}}</li>
                    <li>{{$t("header.titSub1.text4")}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </router-link>
           <router-link :to="{path:'/Hardware'}">
            <div class="right">
              <div class="menuImg"><img src="/static/images/common/ic_web.png" alt=""></div>
              <div>
                <div class="title">{{$t("header.tit2")}}</div>
                <div class="titleSub">
                  <ul>
                    <li>{{$t("header.titSub2.text1")}}</li>
                    <li>{{$t("header.titSub2.text2")}}</li>
                    <li>{{$t("header.titSub2.text3")}}</li>
                    <li>{{$t("header.titSub2.text4")}}</li>
                  </ul>
                </div>
              </div>
            </div>
           </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: 'app-header',
  data() {
    return {
      menuShow:false,
      menuList:[
        {
          name:"menu.Home",
          link:'Home'
        },
        {
          name:"menu.Features",
          link:'Features'
        },
        // {
        //   name:"menu.Products",
        //   link:'Products'
        // },
        {
          name:"menu.FAQ",
          link:'FAQ'
        },
        // {
        //   name:"menu.Blog",
        //   link:'Blog'
        // },
        {
          name:"menu.Contact",
          link:'Contact'
        },
        {
          name:"menu.About",
          link:'About'
        },
      ],
      linkName:'',
      languageList:[
        {
          name:'ZH',
          text:'中文',
          img:'/static/images/common/zh.png'
        },
        // {
        //   name:'EN',
        //   text:' English'
        // },
        {
          name:'PH',
          text:' Philippines',
          img:'/static/images/common/ph.png'
        },
        {
          name:'MA',
          text:' Malayisa',
          img:'/static/images/common/ma.png'
        }
      ],
      language:'EN',
      languageText:'Philippines',
      countryImg:'/static/images/common/ph.png'
    };
  },
  //定义这个sweiper对象
  computed: {

  },
  mounted() {
    this.url_change()
    switch(this.$getCookie('langs')){
      case 'ZH':
      this.languageText = '中文'
      this.countryImg=this.languageList[0].img
      break;
      case 'EN':
      this.languageText = 'English'
      break;
      case 'PH':
      this.languageText = 'Philippines'
      this.countryImg=this.languageList[1].img
      break;
      case 'MA':
      this.languageText = 'Malayisa'
      this.countryImg=this.languageList[2].img
      break;
    }
  },
  methods: {
    handleCommand(el) {
      this.language= el
      this.$i18n.locale = el
      this.$setCookie('langs',el);
      switch(el){
        case 'ZH':
        this.languageText = '中文'
        this.countryImg=this.languageList[0].img
        break;
        case 'EN':
        this.languageText = 'English'
        break;
        case 'PH':
        this.languageText = 'Philippines'
        this.countryImg=this.languageList[1].img
        break;
        case 'MA':
        this.languageText = 'Malayisa'
        this.countryImg=this.languageList[2].img
        break;
      }
    },
    menuShows(){
      this.menuShow = true
    },
    menuHiddens(){
      this.menuShow = false
    },
     url_change () {
        let that = this, url = window.location.href.split('/')[3].split('?')
        let link =''
        if(url[0]=='Software'||url[0]=='Hardware'){
          link = 'Features'
        }else{
          link = url[0]
        }
        that.linkName = link
      }
  },
  watch: {      // 监听路由变化
    $route (to, from) {
      this.url_change()
      this.menuShow = false
    }
  }
};
</script>
<style scoped lang="less" type="text/less">
.el-popper[x-placement^=bottom]{
    margin-top: -10px;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
      color: #27C2B4;
}
#navBar{
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-in;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .navbar{
    height: 65px;
    line-height: 65px;
    background: #fff;
    width: 100%;
    text-align: center;
    box-shadow:0px 3px 10px rgba(0,0,0,0.08);
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 100;
    .nav{
      width: 60%;
      min-width: 960px;
      margin: 0 auto;
      font-size: 16px;
      display: flex;
      justify-content: flex-start;
      position: relative;
      li{
        display: inline-block;
        padding: 0 15px;
        color: #666;
        &:hover{
          cursor: pointer;
        }
        &.active{
          color: #333;
          font-weight: bold;
        }
        &.languageBtn{
          margin-left: 80px;
          font-size: 14px;
          position: absolute;
          right: 60px;

          .langSelect{
            font-weight: bold;
            color: #333;
          }
        }
        // span{
        //   position: relative;
        //   top: 3px;
        // }
      }
    }
  }
  .navMenu{
    position:fixed;
    width: 100%;
    left: 0;
    top: 65px;
    z-index: 8;
    background: #fff;
    padding: 36px 0;
    box-shadow:0px 3px 10px rgba(0,0,0,0.08);
    .con{
      width: 60%;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .left,.right{
        display: flex;
        justify-content: center;
        align-items: center;
        .menuImg{
          margin-right: 30px;
        }
        .title{
          color: #333;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          left: -16px;
        }
        .titleSub{
          padding-top: 10px;
          ul li{
            color: #999;
            font-size: 12px;
            line-height: 24px;
            list-style: disc;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue